import React from 'react';
import {BiCabinet} from 'react-icons/bi';
import {Form, Button} from 'react-bootstrap';
import PropTypes from 'prop-types';
export const DataForm = ({state, setState})=>{
	
	return(
		<>
			<h4 className="display-5 text-center">Please fill below data form for unlock record of <BiCabinet /> {state.scanText}</h4>
			<br />
			<h4>Cut padlock?</h4>
			<br />
			<Form.Check
				type={'radio'}
				id={`cut-padlock-yes-radio`}
				checked={state.info.cutPadlock === "Yes"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{info:{...prevState.info, ...{ cutPadlock: "Yes" }} } }
					})
				}}
				label={`Yes`}
			/>
			<br />
			<Form.Check
				type={'radio'}
				id={`cut-padlock-no-radio`}
				checked={state.info.cutPadlock === "No"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{info:{...prevState.info, ...{ cutPadlock: "No" }} } }
					})
				}}
				label={`No`}
			/>
			<br />
			<h4>Items found?</h4>
			<br />
			<Form.Check
				type={'radio'}
				id={`items-found-yes-radio`}
				checked={state.info.itemsFound === "Yes"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{info:{...prevState.info, ...{ itemsFound: "Yes" }} } }
					})
				}}
				label={`Yes`}
			/>
			<br />
			<Form.Check
				type={'radio'}
				id={`items-found-no-check-box`}
				checked={state.info.itemsFound === "No"}
				onChange={(event) => {
					setState((prevState) => {
						return { ...prevState, ...{info:{...prevState.info, ...{ itemsFound: "No" }} } }
					})
				}}
				label={`No`}
			/>
			<br />
			<Button block variant="success" className="text-center"
				onClick={() => {
					setState(prevState => {
						return { ...prevState, ...{ stage: "DATA_CONFIRM" } };
					})
				}}>
				Confirm
			</Button>
		</>
	)
}
DataForm.propTypes = {
	state: PropTypes.object,
	setState: PropTypes.func
};
